export enum StreamMode {
  DEFAULT = 'DEFAULT',
  EDITOR = 'EDITOR',
}
